import type { BoardConfig } from "./types";
import { MAX_TIER } from "./tiers";

/**
 * Daily challenge: a fixed board shared by all players on a given UTC date.
 * The seed/config are derived from the date so it works fully offline; the
 * server mirrors the same values (functions/_lib/router.ts) and liveops may
 * override them.
 */

export const DAILY_DROP_LIMIT = 50;

export function todayKey(date = new Date()): string {
  return date.toISOString().slice(0, 10); // YYYY-MM-DD (UTC)
}

export function dailySeed(dateKey: string): string {
  return `daily-${dateKey}`;
}

export function dailyConfig(cols = 5): BoardConfig {
  return {
    cols,
    rows: 8,
    // Richer spawn for the 3-merge rule (kept in sync with the server, §5.5).
    spawnTable: { "1": 0.34, "2": 0.3, "3": 0.22, "4": 0.14 },
    maxTier: MAX_TIER,
  };
}

/** Day difference between two YYYY-MM-DD keys (b - a) in whole days. */
export function dayDiff(a: string, b: string): number {
  const ta = Date.parse(`${a}T00:00:00Z`);
  const tb = Date.parse(`${b}T00:00:00Z`);
  if (Number.isNaN(ta) || Number.isNaN(tb)) return Infinity;
  return Math.round((tb - ta) / 86_400_000);
}
